
import intersectionAnchor from '~/patterns/atoms/intersection-anchor/intersection-anchor.vue';

export default {
    components: {
        intersectionAnchor
    },
};
